(function() {
  'use strict';

  function text(value, limit) {
    return String(value == null ? '' : value).trim().slice(0, limit || 500);
  }

  function money(cents) {
    return new Intl.NumberFormat('ro-RO', {
      style: 'currency',
      currency: 'RON',
      minimumFractionDigits: 2
    }).format((Number(cents) || 0) / 100);
  }

  function serviceMinimum(service, config) {
    var configured = config && config.serviceMinQuantities && Number(config.serviceMinQuantities[service]);
    if (Number.isFinite(configured) && configured > 0) return configured;
    return service === 'followers' ? 250 : 50;
  }

  function request(url, payload, timeout) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller ? window.setTimeout(function() { controller.abort(); }, timeout || 20000) : null;
    return fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      credentials: 'omit',
      signal: controller ? controller.signal : undefined,
      body: JSON.stringify(payload)
    }).then(function(response) {
      return response.json().catch(function() { return {}; }).then(function(body) {
        if (!response.ok || body.ok === false) {
          var error = new Error(text(body.error, 240) || 'Serviciul este temporar indisponibil.');
          error.status = response.status;
          throw error;
        }
        return body;
      });
    }).finally(function() {
      if (timer) window.clearTimeout(timer);
    });
  }

  function instagramUrl(value, kind) {
    try {
      var url = new URL(text(value, 500));
      var hostname = url.hostname.toLowerCase().replace(/^www\./, '');
      var parts = url.pathname.split('/').filter(Boolean);
      if (url.protocol !== 'https:' || hostname !== 'instagram.com') return null;
      if (kind === 'profile') {
        if (!parts[0] || /^(p|reel|tv|stories|explore)$/i.test(parts[0]) || !/^[a-z0-9._]{1,30}$/i.test(parts[0])) return null;
        return { url: 'https://www.instagram.com/' + parts[0].toLowerCase() + '/', username: parts[0].toLowerCase() };
      }
      if (!/^(p|reel|tv)$/i.test(parts[0] || '') || !/^[a-z0-9_-]+$/i.test(parts[1] || '')) return null;
      return { url: 'https://www.instagram.com/' + parts[0].toLowerCase() + '/' + parts[1] + '/' };
    } catch (error) {
      return null;
    }
  }

  function sessionId() {
    var key = 'faima_stacked_services_session_id';
    var value = '';
    try {
      value = String(window.sessionStorage.getItem(key) || '');
      if (!value) {
        value = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : 'stacked-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
        window.sessionStorage.setItem(key, value);
      }
    } catch (error) {
      value = 'stacked-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    }
    return value;
  }

  function upsellMarkup(service, serviceLabel, targetLabel, placeholder) {
    var minimum = serviceMinimum(service, null);
    var maximum = minimum * 2;
    return '' +
      '<aside class="faima-dual-exclusive faima-dual-package-upsell" data-dual-upsell="' + service + '">' +
        '<span class="faima-dual-exclusive-icon" aria-hidden="true">🚀</span>' +
        '<span class="faima-dual-exclusive-copy"><small>Upgrade exclusiv</small><strong>Mai adaugă ' + serviceLabel + ' la jumătate de preț</strong></span>' +
        '<button type="button" class="faima-dual-exclusive-button" data-dual-upsell-action="' + service + '" aria-pressed="false">Adaugă upsell</button>' +
        '<div class="faima-dual-exclusive-panel" data-dual-upsell-panel="' + service + '" hidden>' +
          '<div class="faima-dual-secondary-quantity">' +
            '<span class="faima-dual-secondary-kicker">Cantitate separată</span>' +
            '<strong>Alege cantitatea la jumătate de preț</strong>' +
            '<span class="faima-dual-secondary-value" data-dual-upsell-value="' + service + '">' + minimum + '</span>' +
            '<div class="faima-dual-quantity-row dynamic-quantity-controls">' +
              '<button type="button" class="faima-dual-step dynamic-quantity-button" data-dual-upsell-step="' + service + '" data-direction="-1" aria-label="Scade cantitatea de upsell">−</button>' +
              '<input class="faima-dual-quantity dynamic-quantity-input" type="number" inputmode="numeric" value="' + minimum + '" min="' + minimum + '" max="' + maximum + '" step="1" data-dual-upsell-quantity="' + service + '" aria-label="Cantitate de upsell">' +
              '<button type="button" class="faima-dual-step dynamic-quantity-button" data-dual-upsell-step="' + service + '" data-direction="1" aria-label="Crește cantitatea de upsell">+</button>' +
            '</div>' +
            '<input class="faima-dual-range dynamic-quantity-slider" type="range" value="' + minimum + '" min="' + minimum + '" max="' + maximum + '" step="10" data-dual-upsell-range="' + service + '" aria-label="Alege cantitatea de upsell">' +
            '<span class="faima-dual-range-labels dynamic-quantity-range"><span>' + minimum + '</span><span data-dual-upsell-max="' + service + '">' + maximum + '</span></span>' +
            '<span class="faima-dual-secondary-price">Preț la jumătate: <strong data-dual-upsell-price="' + service + '">—</strong></span>' +
          '</div>' +
          '<label class="faima-dual-alternate-toggle">' +
            '<input type="checkbox" data-dual-upsell-alternate="' + service + '">' +
            '<span>Folosește alt link</span>' +
          '</label>' +
          '<label class="faima-dual-link-group" data-dual-upsell-link-group="' + service + '" hidden>' +
            '<span class="faima-dual-link-label">' + targetLabel + '</span>' +
            '<input class="faima-dual-link" type="url" inputmode="url" autocomplete="url" placeholder="' + placeholder + '" data-dual-upsell-link="' + service + '">' +
          '</label>' +
          '<p class="faima-dual-link-note">Dacă nu bifezi „Folosește alt link”, păstrăm linkul completat mai sus.</p>' +
        '</div>' +
      '</aside>';
  }

  function DualServices(root) {
    this.root = root;
    this.selector = root.querySelector('[data-service-selector]');
    this.checkout = root.querySelector('[data-checkout-button]');
    this.terms = root.querySelector('[data-terms-checkbox]');
    this.services = new Set(['followers']);
    this.quantities = { followers: 250, likes: 50 };
    this.profileLink = '';
    this.postLink = '';
    this.upsells = {
      followers: { enabled: false, quantity: 250, useAlternate: false, link: '' },
      likes: { enabled: false, quantity: 50, useAlternate: false, link: '' }
    };
    this.config = null;
    this.quote = null;
    this.quoteFailed = false;
    this.quoteSequence = 0;
    this.quoteTimer = null;
    this.busy = false;
    this.session = sessionId();
    this.endpoints = {
      pricing: 'https://panel.faimainstant.ro/api/faima/dynamic-pricing',
      quote: 'https://panel.faimainstant.ro/api/faima/instagram/order-quote',
      checkout: 'https://panel.faimainstant.ro/api/faima/dynamic-checkout'
    };
    if (!this.selector || !this.checkout || !window.FaimaDynamicPricing) return;
    this.mount();
  }

  DualServices.prototype.mount = function() {
    var self = this;
    this.root.classList.add('faima-dual-services-active');
    this.selector.dataset.dualServicesReady = 'true';
    this.selector.setAttribute('role', 'group');
    this.selector.setAttribute('aria-label', 'Alege urmăritori, like-uri sau ambele servicii');
    this.selector.innerHTML = this.markup();
    this.status = this.selector.querySelector('[data-dual-status]');
    this.summary = this.selector.querySelector('[data-dual-summary]');
    this.bind();
    this.root.faimaDualServicesRefresh = function() { self.update(); };
    this.update();
    fetch(this.endpoints.pricing, { headers: { Accept: 'application/json' }, credentials: 'omit' })
      .then(function(response) { return response.ok ? response.json() : Promise.reject(new Error('pricing_unavailable')); })
      .then(function(payload) {
        if (!payload.config || Number(payload.config.maxQuantity) < 10000) throw new Error('pricing_limit_unavailable');
        self.config = payload.config;
        self.quantities.followers = serviceMinimum('followers', payload.config);
        self.quantities.likes = serviceMinimum('likes', payload.config);
        self.upsells.followers.quantity = serviceMinimum('followers', payload.config);
        self.upsells.likes.quantity = serviceMinimum('likes', payload.config);
        self.update();
      })
      .catch(function() {
        self.show('Actualizăm pachetele până la 100.000. Reîncarcă pagina în câteva momente.', true);
      });
  };

  DualServices.prototype.markup = function() {
    return '' +
      '<article class="faima-dual-service" data-dual-card="followers">' +
        '<button type="button" class="faima-dual-service-toggle" data-dual-toggle="followers" aria-pressed="false" aria-expanded="false">' +
          '<span class="faima-dual-service-icon" aria-hidden="true">👥</span>' +
          '<span class="faima-dual-service-copy">' +
            '<strong class="faima-dual-service-title">Urmăritori</strong>' +
          '</span>' +
          '<span class="faima-dual-service-check" aria-hidden="true">✓</span>' +
        '</button>' +
        '<div class="faima-dual-service-panel" data-dual-panel="followers" hidden>' +
          '<div class="faima-dual-package variant-card faima-dynamic-card is-selected" data-dual-package-card="followers">' +
            '<span class="faima-dual-brand-mark" aria-label="Faima Instant"><img src="//faimainstant.ro/cdn/shop/files/IMG_3706_66a09ea8-6667-4f33-8555-1e8c428790e1.webp?v=1771257398&amp;width=160" alt="Faima Instant" loading="lazy"></span>' +
            '<span class="variant-card-quantity-line"><span class="variant-card-quantity" data-dual-card-quantity="followers">250</span><span class="variant-card-public-bonus" data-dual-card-bonus="followers">+50 GRATUIT!</span></span>' +
            '<span class="variant-card-subtitle">Urmăritori</span>' +
            '<span class="variant-card-price-row"><span class="variant-card-price" data-dual-price="followers">—</span></span>' +
            '<span class="variant-card-saving" data-dual-saving="followers">Reducere 0%</span>' +
            '<div class="faima-dual-quantity-row dynamic-quantity-controls">' +
              '<button type="button" class="faima-dual-step dynamic-quantity-button" data-dual-step="followers" data-direction="-1" aria-label="Scade numărul de urmăritori">−</button>' +
              '<input class="faima-dual-quantity dynamic-quantity-input" type="number" inputmode="numeric" value="250" min="250" max="10000" step="1" data-dual-quantity="followers" aria-label="Număr de urmăritori">' +
              '<button type="button" class="faima-dual-step dynamic-quantity-button" data-dual-step="followers" data-direction="1" aria-label="Crește numărul de urmăritori">+</button>' +
            '</div>' +
            '<input class="faima-dual-range dynamic-quantity-slider" type="range" value="250" min="250" max="10000" step="50" data-dual-range="followers" aria-label="Alege numărul de urmăritori">' +
            '<span class="faima-dual-range-labels dynamic-quantity-range"><span>250</span><span>10.000</span></span>' +
            '<span class="faima-dual-benefits" aria-label="Beneficii pachet">' +
              '<span>🇺🇸 Locație USA &amp; România 🇷🇴</span>' +
              '<span>⚡ Livrare rapidă</span>' +
              '<span>⭐ Conturi calitative</span>' +
              '<span>💬 Asistență 24/7</span>' +
              '<span>♻️ 30 de zile Refill</span>' +
            '</span>' +
            '<label class="faima-dual-link-group">' +
              '<span class="faima-dual-link-label">Link profil Instagram</span>' +
              '<input class="faima-dual-link" type="url" inputmode="url" autocomplete="url" placeholder="https://www.instagram.com/profil/" data-dual-profile-link>' +
            '</label>' +
            upsellMarkup('followers', 'urmăritori', 'Link profil Instagram pentru upsell', 'https://www.instagram.com/alt-profil/') +
          '</div>' +
        '</div>' +
      '</article>' +
      '<article class="faima-dual-service" data-dual-card="likes">' +
        '<button type="button" class="faima-dual-service-toggle" data-dual-toggle="likes" aria-pressed="false" aria-expanded="false">' +
          '<span class="faima-dual-service-icon" aria-hidden="true">❤️</span>' +
          '<span class="faima-dual-service-copy">' +
            '<strong class="faima-dual-service-title">Like-uri</strong>' +
          '</span>' +
          '<span class="faima-dual-service-check" aria-hidden="true">✓</span>' +
        '</button>' +
        '<div class="faima-dual-service-panel" data-dual-panel="likes" hidden>' +
          '<div class="faima-dual-package variant-card faima-dynamic-card is-selected" data-dual-package-card="likes">' +
            '<span class="faima-dual-brand-mark" aria-label="Faima Instant"><img src="//faimainstant.ro/cdn/shop/files/IMG_3706_66a09ea8-6667-4f33-8555-1e8c428790e1.webp?v=1771257398&amp;width=160" alt="Faima Instant" loading="lazy"></span>' +
            '<span class="variant-card-quantity-line"><span class="variant-card-quantity" data-dual-card-quantity="likes">50</span><span class="variant-card-public-bonus" data-dual-card-bonus="likes">+10 GRATUIT!</span></span>' +
            '<span class="variant-card-subtitle">Like-uri</span>' +
            '<span class="variant-card-price-row"><span class="variant-card-price" data-dual-price="likes">—</span></span>' +
            '<span class="variant-card-saving" data-dual-saving="likes">Reducere 0%</span>' +
            '<div class="faima-dual-quantity-row dynamic-quantity-controls">' +
              '<button type="button" class="faima-dual-step dynamic-quantity-button" data-dual-step="likes" data-direction="-1" aria-label="Scade numărul de like-uri">−</button>' +
              '<input class="faima-dual-quantity dynamic-quantity-input" type="number" inputmode="numeric" value="50" min="50" max="10000" step="1" data-dual-quantity="likes" aria-label="Număr de like-uri">' +
              '<button type="button" class="faima-dual-step dynamic-quantity-button" data-dual-step="likes" data-direction="1" aria-label="Crește numărul de like-uri">+</button>' +
            '</div>' +
            '<input class="faima-dual-range dynamic-quantity-slider" type="range" value="50" min="50" max="10000" step="10" data-dual-range="likes" aria-label="Alege numărul de like-uri">' +
            '<span class="faima-dual-range-labels dynamic-quantity-range"><span>50</span><span>10.000</span></span>' +
            '<span class="faima-dual-benefits" aria-label="Beneficii pachet">' +
              '<span>🇺🇸 Locație USA &amp; România 🇷🇴</span>' +
              '<span>⚡ Livrare rapidă</span>' +
              '<span>⭐ Conturi calitative</span>' +
              '<span>💬 Asistență 24/7</span>' +
              '<span>♻️ 30 de zile Refill</span>' +
            '</span>' +
            '<label class="faima-dual-link-group" data-dual-post-group>' +
              '<span class="faima-dual-link-label">Link postare sau Reel Instagram</span>' +
              '<input class="faima-dual-link" type="url" inputmode="url" autocomplete="url" placeholder="https://www.instagram.com/p/.../" data-dual-post-link>' +
              '<span class="faima-dual-link-note">Postarea și profilul trebuie să fie publice.</span>' +
            '</label>' +
            upsellMarkup('likes', 'like-uri', 'Link postare sau Reel pentru upsell', 'https://www.instagram.com/p/.../') +
          '</div>' +
        '</div>' +
      '</article>' +
      '<div class="faima-dual-summary" data-dual-summary hidden>' +
        '<div class="faima-dual-summary-row" data-dual-summary-followers></div>' +
        '<div class="faima-dual-summary-row" data-dual-summary-likes></div>' +
        '<div class="faima-dual-summary-row" data-dual-summary-upsell="followers" hidden></div>' +
        '<div class="faima-dual-summary-row" data-dual-summary-upsell="likes" hidden></div>' +
        '<div class="faima-dual-summary-row faima-dual-summary-total"><span>Total estimat</span><strong data-dual-total>—</strong></div>' +
      '</div>' +
      '<p class="faima-dual-status" data-dual-status role="status" aria-live="polite"></p>';
  };

  DualServices.prototype.bind = function() {
    var self = this;
    this.selector.addEventListener('click', function(event) {
      var toggle = event.target.closest('[data-dual-toggle]');
      var step = event.target.closest('[data-dual-step]');
      var upsellStep = event.target.closest('[data-dual-upsell-step]');
      var upsell = event.target.closest('[data-dual-upsell-action]');
      if (toggle) {
        self.toggle(toggle.getAttribute('data-dual-toggle'));
        return;
      }
      if (upsellStep) {
        var upsellService = upsellStep.getAttribute('data-dual-upsell-step');
        self.setUpsellQuantity(upsellService, self.upsells[upsellService].quantity + self.stepFor(self.upsells[upsellService].quantity) * Number(upsellStep.getAttribute('data-direction') || 0));
        return;
      }
      if (step) {
        var service = step.getAttribute('data-dual-step');
        self.setQuantity(service, self.quantities[service] + self.stepFor(self.quantities[service]) * Number(step.getAttribute('data-direction') || 0));
        return;
      }
      if (upsell) {
        var service = upsell.getAttribute('data-dual-upsell-action');
        self.upsells[service].enabled = !self.upsells[service].enabled;
        if (!self.upsells[service].enabled) {
          self.upsells[service].useAlternate = false;
          self.upsells[service].link = '';
        }
        self.invalidateQuote();
        self.update();
      }
    });
    this.selector.addEventListener('input', function(event) {
      if (event.target.matches('[data-dual-profile-link], [data-dual-post-link], [data-dual-upsell-link]')) {
        self.clearFieldError(event.target);
      }
      if (event.target.matches('[data-dual-quantity], [data-dual-range]')) {
        self.setQuantity(event.target.getAttribute('data-dual-quantity') || event.target.getAttribute('data-dual-range'), event.target.value, false);
      }
      if (event.target.matches('[data-dual-upsell-quantity], [data-dual-upsell-range]')) {
        self.setUpsellQuantity(event.target.getAttribute('data-dual-upsell-quantity') || event.target.getAttribute('data-dual-upsell-range'), event.target.value, false);
      }
      if (event.target.matches('[data-dual-profile-link]')) {
        self.profileLink = event.target.value;
        self.selector.querySelectorAll('[data-dual-profile-link]').forEach(function(input) {
          if (input !== event.target) input.value = self.profileLink;
        });
        self.invalidateQuote();
      }
      if (event.target.matches('[data-dual-post-link]')) {
        self.postLink = event.target.value;
        self.invalidateQuote();
      }
      if (event.target.matches('[data-dual-upsell-alternate]')) {
        var alternateService = event.target.getAttribute('data-dual-upsell-alternate');
        self.upsells[alternateService].useAlternate = event.target.checked;
        if (!event.target.checked) self.upsells[alternateService].link = '';
        self.invalidateQuote();
        self.update();
      }
      if (event.target.matches('[data-dual-upsell-link]')) {
        self.upsells[event.target.getAttribute('data-dual-upsell-link')].link = event.target.value;
        self.invalidateQuote();
      }
    });
    this.checkout.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      self.startCheckout();
    }, true);
    if (this.terms) this.terms.addEventListener('change', function() { self.updateCheckout(); });
  };

  DualServices.prototype.toggle = function(service) {
    if (this.services.has(service)) {
      this.services.delete(service);
    } else {
      this.services.add(service);
    }
    if (!this.services.has(service)) {
      this.upsells[service].enabled = false;
      this.upsells[service].useAlternate = false;
      this.upsells[service].link = '';
    }
    this.upsells[service].quantity = Math.min(this.upsells[service].quantity, this.upsellMaximum(service));
    this.invalidateQuote();
    this.update();
  };

  DualServices.prototype.stepFor = function(quantity) {
    if (quantity < 100) return 10;
    if (quantity < 1000) return 50;
    if (quantity < 10000) return 100;
    if (quantity < 50000) return 1000;
    return 5000;
  };

  DualServices.prototype.setQuantity = function(service, raw, rerender) {
    var minimum = serviceMinimum(service, this.config);
    var maximum = this.config ? Number(this.config.maxQuantity) : 10000;
    var value = Math.max(minimum, Math.min(maximum, Math.round(Number(raw) || minimum)));
    this.quantities[service] = value;
    this.upsells[service].quantity = Math.min(this.upsells[service].quantity, this.upsellMaximum(service));
    this.invalidateQuote();
    if (rerender !== false) this.update(); else this.updateQuantities();
  };

  DualServices.prototype.setUpsellQuantity = function(service, raw, rerender) {
    var minimum = serviceMinimum(service, this.config);
    var maximum = this.upsellMaximum(service);
    this.upsells[service].quantity = Math.max(minimum, Math.min(maximum, Math.round(Number(raw) || minimum)));
    this.invalidateQuote();
    if (rerender !== false) this.update(); else this.updateQuantities();
  };

  DualServices.prototype.upsellMaximum = function(service) {
    var maximum = this.config ? Number(this.config.maxQuantity) : 10000;
    if (!this.services.has(service)) return serviceMinimum(service, this.config);
    return Math.min(maximum, this.quantities[service] * 2);
  };

  DualServices.prototype.calculation = function(service) {
    if (!this.config) return null;
    try {
      return window.FaimaDynamicPricing.calculate(this.config, service, this.quantities[service]);
    } catch (error) {
      return null;
    }
  };

  DualServices.prototype.clearFieldError = function(input) {
    if (!input) return;
    input.removeAttribute('aria-invalid');
    var group = input.closest('.faima-dual-link-group');
    var error = group && group.querySelector('[data-dual-field-error]');
    if (error) error.remove();
  };

  DualServices.prototype.failField = function(input, message, showMessage) {
    if (!showMessage || !input) return false;
    this.clearFieldError(input);
    input.setAttribute('aria-invalid', 'true');
    var group = input.closest('.faima-dual-link-group');
    if (group) {
      var error = document.createElement('span');
      error.className = 'faima-dual-field-error';
      error.setAttribute('data-dual-field-error', 'true');
      error.setAttribute('role', 'alert');
      error.textContent = message;
      group.appendChild(error);
    }
    this.show(message, true);
    input.scrollIntoView({ behavior: 'smooth', block: 'center' });
    window.setTimeout(function() { input.focus({ preventScroll: true }); }, 250);
    return false;
  };

  DualServices.prototype.payload = function() {
    var profile = instagramUrl(this.profileLink, 'profile');
    var post = instagramUrl(this.postLink, 'post');
    var payload = profile ? { username: profile.username, profileUrl: profile.url } : {};
    if (this.services.has('followers')) payload.followersQuantity = this.quantities.followers;
    if (this.services.has('likes')) {
      payload.likesQuantityPerPost = this.quantities.likes;
      if (post) payload.manualPostUrls = [post.url];
    }
    if (this.upsells.followers.enabled) {
      var followersTarget = instagramUrl(this.upsells.followers.useAlternate ? this.upsells.followers.link : this.profileLink, 'profile');
      payload.followersUpsellQuantity = this.upsells.followers.quantity;
      if (followersTarget) payload.followersUpsellProfileUrl = followersTarget.url;
    }
    if (this.upsells.likes.enabled) {
      var likesTarget = instagramUrl(this.upsells.likes.useAlternate ? this.upsells.likes.link : this.postLink, 'post');
      payload.likesUpsellQuantityPerPost = this.upsells.likes.quantity;
      if (likesTarget) payload.likesUpsellPostUrls = [likesTarget.url];
    }
    return payload;
  };

  DualServices.prototype.isValid = function(showMessage) {
    if (this.services.size === 0) {
      if (showMessage) this.show('Alege Urmăritori, Like-uri sau ambele servicii.', true);
      return false;
    }
    if (this.services.has('followers') && !instagramUrl(this.profileLink, 'profile')) {
      return this.failField(
        this.selector.querySelector('[data-dual-profile-link]'),
        'La Urmăritori trebuie introdus un link de profil Instagram, nu un link de postare.',
        showMessage
      );
    }
    if (this.services.has('likes') && !instagramUrl(this.postLink, 'post')) {
      return this.failField(
        this.selector.querySelector('[data-dual-post-link]'),
        'La Like-uri trebuie introdus linkul unei postări sau al unui Reel Instagram, nu linkul profilului.',
        showMessage
      );
    }
    if (this.upsells.followers.enabled && this.upsells.followers.useAlternate && !instagramUrl(this.upsells.followers.link, 'profile')) {
      return this.failField(
        this.selector.querySelector('[data-dual-upsell-link="followers"]'),
        'Pentru upsellul de urmăritori trebuie introdus un link de profil Instagram.',
        showMessage
      );
    }
    if (this.upsells.likes.enabled && this.upsells.likes.useAlternate && !instagramUrl(this.upsells.likes.link, 'post')) {
      return this.failField(
        this.selector.querySelector('[data-dual-upsell-link="likes"]'),
        'Pentru upsellul de like-uri trebuie introdus linkul unei postări sau al unui Reel Instagram.',
        showMessage
      );
    }
    return true;
  };

  DualServices.prototype.invalidateQuote = function() {
    this.quote = null;
    this.quoteFailed = false;
    this.quoteSequence += 1;
    window.clearTimeout(this.quoteTimer);
    this.show('', false);
    this.updateSummary();
    this.updateCheckout();
    if (!this.config || !this.isValid(false)) return;
    this.scheduleQuote();
  };

  DualServices.prototype.scheduleQuote = function() {
    var self = this;
    var sequence = ++this.quoteSequence;
    window.clearTimeout(this.quoteTimer);
    this.quoteFailed = false;
    this.show('Verificăm linkurile și calculăm totalul…', false);
    this.quoteTimer = window.setTimeout(function() {
      request(self.endpoints.quote, { instagramOrder: self.payload() }, 24000)
        .then(function(payload) {
          if (sequence !== self.quoteSequence) return;
          self.quote = payload;
          self.quoteFailed = false;
          self.show('Linkurile sunt verificate. Poți continua către checkout.', false);
          self.updateSummary();
          self.updateCheckout();
        })
        .catch(function(error) {
          if (sequence !== self.quoteSequence) return;
          self.quote = null;
          self.quoteFailed = true;
          self.show(error.message || 'Nu am putut verifica linkurile.', true);
          self.updateCheckout();
        });
    }, 550);
  };

  DualServices.prototype.quoteTotal = function() {
    var quoted = Number(this.quote && (this.quote.totalPriceCents || this.quote.total_price_cents || (this.quote.order && this.quote.order.total_price_cents)));
    if (quoted) return quoted;
    var followers = this.services.has('followers') ? this.calculation('followers') : null;
    var likes = this.services.has('likes') ? this.calculation('likes') : null;
    var primaryTotal = (followers ? followers.finalPriceCents : 0) + (likes ? likes.finalPriceCents : 0);
    var upsellTotal = 0;
    if (this.upsells.followers.enabled) upsellTotal += Math.round(window.FaimaDynamicPricing.calculate(this.config, 'followers', this.upsells.followers.quantity).finalPriceCents / 2);
    if (this.upsells.likes.enabled) upsellTotal += Math.round(window.FaimaDynamicPricing.calculate(this.config, 'likes', this.upsells.likes.quantity).finalPriceCents / 2);
    return primaryTotal + upsellTotal;
  };

  DualServices.prototype.updateQuantities = function() {
    var self = this;
    ['followers', 'likes'].forEach(function(service) {
      var calculation = self.calculation(service);
      var input = self.selector.querySelector('[data-dual-quantity="' + service + '"]');
      var range = self.selector.querySelector('[data-dual-range="' + service + '"]');
      var price = self.selector.querySelector('[data-dual-price="' + service + '"]');
      var quantityText = self.selector.querySelector('[data-dual-card-quantity="' + service + '"]');
      var bonusText = self.selector.querySelector('[data-dual-card-bonus="' + service + '"]');
      var saving = self.selector.querySelector('[data-dual-saving="' + service + '"]');
      var packageCard = self.selector.querySelector('[data-dual-package-card="' + service + '"]');
      var minimum = serviceMinimum(service, self.config);
      var maximum = self.config ? Number(self.config.maxQuantity) : 10000;
      [input, range].forEach(function(node) {
        if (!node) return;
        node.min = String(minimum);
        node.max = String(maximum);
        if (Number(node.value) !== self.quantities[service]) node.value = String(self.quantities[service]);
      });
      if (price) price.textContent = calculation ? money(calculation.finalPriceCents) : '—';
      if (quantityText) quantityText.textContent = self.quantities[service].toLocaleString('ro-RO');
      if (bonusText) {
        bonusText.hidden = false;
        bonusText.textContent = '+' + Math.ceil(self.quantities[service] * 0.2).toLocaleString('ro-RO') + ' GRATUIT!';
      }
      if (saving) saving.textContent = calculation ? 'Reducere ' + Number(calculation.discountPercent || 0).toLocaleString('ro-RO') + '%' : '';
      if (packageCard) {
        ['tier-basic', 'tier-premium', 'tier-elite', 'tier-pro', 'tier-max'].forEach(function(name) { packageCard.classList.remove(name); });
        if (calculation && calculation.tier) packageCard.classList.add(String(calculation.tier).replace('TIER_', 'tier-').toLowerCase());
      }
    });
    ['followers', 'likes'].forEach(function(service) {
      var upsell = self.upsells[service];
      var upsellInput = self.selector.querySelector('[data-dual-upsell-quantity="' + service + '"]');
      var upsellRange = self.selector.querySelector('[data-dual-upsell-range="' + service + '"]');
      var upsellValue = self.selector.querySelector('[data-dual-upsell-value="' + service + '"]');
      var upsellPrice = self.selector.querySelector('[data-dual-upsell-price="' + service + '"]');
      var upsellMaxLabel = self.selector.querySelector('[data-dual-upsell-max="' + service + '"]');
      var upsellMinimum = serviceMinimum(service, self.config);
      var upsellMaximum = self.upsellMaximum(service);
      if (upsell.quantity > upsellMaximum) upsell.quantity = upsellMaximum;
      [upsellInput, upsellRange].forEach(function(node) {
        if (!node) return;
        node.min = String(upsellMinimum);
        node.max = String(upsellMaximum);
        if (Number(node.value) !== upsell.quantity) node.value = String(upsell.quantity);
      });
      if (upsellValue) upsellValue.textContent = upsell.quantity.toLocaleString('ro-RO');
      if (upsellMaxLabel) upsellMaxLabel.textContent = upsellMaximum.toLocaleString('ro-RO');
      if (upsellPrice) {
        var calculated = self.config ? window.FaimaDynamicPricing.calculate(self.config, service, upsell.quantity) : null;
        upsellPrice.textContent = calculated ? money(Math.round(calculated.finalPriceCents / 2)) : '—';
      }
    });
    this.updateSummary();
    this.updateUpsells();
    this.updateCheckout();
  };

  DualServices.prototype.update = function() {
    var self = this;
    ['followers', 'likes'].forEach(function(service) {
      var selected = self.services.has(service);
      var card = self.selector.querySelector('[data-dual-card="' + service + '"]');
      var toggle = self.selector.querySelector('[data-dual-toggle="' + service + '"]');
      var panel = self.selector.querySelector('[data-dual-panel="' + service + '"]');
      if (card) card.classList.toggle('is-selected', selected);
      if (toggle) {
        toggle.setAttribute('aria-pressed', selected ? 'true' : 'false');
        toggle.setAttribute('aria-expanded', selected ? 'true' : 'false');
      }
      if (panel) panel.hidden = !selected;
    });
    this.selector.querySelectorAll('[data-dual-profile-link]').forEach(function(input) { input.value = self.profileLink; });
    var postGroup = this.selector.querySelector('[data-dual-post-group]');
    var post = this.selector.querySelector('[data-dual-post-link]');
    if (postGroup) postGroup.hidden = !this.services.has('likes');
    if (post) post.value = this.postLink;
    ['followers', 'likes'].forEach(function(service) {
      var upsell = self.upsells[service];
      var panel = self.selector.querySelector('[data-dual-upsell-panel="' + service + '"]');
      var alternate = self.selector.querySelector('[data-dual-upsell-alternate="' + service + '"]');
      var linkGroup = self.selector.querySelector('[data-dual-upsell-link-group="' + service + '"]');
      var link = self.selector.querySelector('[data-dual-upsell-link="' + service + '"]');
      if (panel) panel.hidden = !upsell.enabled;
      if (alternate) alternate.checked = upsell.useAlternate;
      if (linkGroup) linkGroup.hidden = !upsell.enabled || !upsell.useAlternate;
      if (link) link.value = upsell.link;
    });
    this.updateQuantities();
    this.invalidateQuote();
  };

  DualServices.prototype.updateSummary = function() {
    var followersRow = this.selector.querySelector('[data-dual-summary-followers]');
    var likesRow = this.selector.querySelector('[data-dual-summary-likes]');
    var total = this.selector.querySelector('[data-dual-total]');
    if (this.summary) this.summary.hidden = !this.config || this.services.size === 0;
    if (followersRow) {
      followersRow.hidden = !this.services.has('followers');
      followersRow.innerHTML = this.services.has('followers')
        ? '<span>Urmăritori</span><strong>' + this.quantities.followers.toLocaleString('ro-RO') + '</strong>'
        : '';
    }
    if (likesRow) {
      likesRow.hidden = !this.services.has('likes');
      likesRow.innerHTML = this.services.has('likes')
        ? '<span>Like-uri / postare</span><strong>' + this.quantities.likes.toLocaleString('ro-RO') + '</strong>'
        : '';
    }
    var self = this;
    ['followers', 'likes'].forEach(function(service) {
      var row = self.selector.querySelector('[data-dual-summary-upsell="' + service + '"]');
      var upsell = self.upsells[service];
      if (!row) return;
      row.hidden = !upsell.enabled;
      row.innerHTML = upsell.enabled
        ? '<span>Upsell ' + (service === 'followers' ? 'urmăritori' : 'like-uri') + ' · 50%</span><strong>' + upsell.quantity.toLocaleString('ro-RO') + '</strong>'
        : '';
    });
    if (total) total.textContent = this.config ? money(this.quoteTotal()) : '—';
  };

  DualServices.prototype.updateUpsells = function() {
    var self = this;
    ['followers', 'likes'].forEach(function(service) {
      var container = self.selector.querySelector('[data-dual-upsell="' + service + '"]');
      var button = self.selector.querySelector('[data-dual-upsell-action="' + service + '"]');
      if (container) container.hidden = !self.services.has(service);
      if (button) {
        button.textContent = self.upsells[service].enabled ? 'Elimină upsellul' : 'Adaugă upsell';
        button.setAttribute('aria-pressed', self.upsells[service].enabled ? 'true' : 'false');
      }
    });
  };

  DualServices.prototype.updateCheckout = function() {
    if (!this.checkout) return;
    var linksComplete = this.isValid(false);
    var canAttempt = this.services.size > 0 && !this.busy;
    this.checkout.disabled = !canAttempt;
    this.checkout.setAttribute('aria-disabled', canAttempt ? 'false' : 'true');
    if (!this.busy) {
      this.checkout.textContent = this.services.size === 0
        ? 'Alege un serviciu'
        : (!linksComplete
          ? 'Completează linkurile pentru checkout'
          : (this.quote
            ? 'Continuă către checkout'
            : (this.quoteFailed ? 'Verificarea linkurilor este indisponibilă' : 'Verificăm linkurile…')));
    }
  };

  DualServices.prototype.startCheckout = function() {
    var self = this;
    if (this.busy) return;
    if (!this.isValid(true)) return;
    if (this.terms && !this.terms.checked) {
      this.show('Acceptă Termenii și Condițiile pentru a continua.', true);
      this.terms.focus();
      return;
    }
    if (!this.quote) {
      this.show('Așteaptă verificarea linkurilor înainte de checkout.', true);
      this.scheduleQuote();
      return;
    }
    this.busy = true;
    this.checkout.disabled = true;
    this.checkout.textContent = 'Pregătim checkout-ul securizat…';
    request(this.endpoints.checkout, {
      instagramOrder: this.payload(),
      quoteToken: this.quote.quoteToken || this.quote.token || null,
      checkoutSessionId: this.session
    }, 30000)
      .then(function(payload) {
        var url = text(payload.checkoutUrl || payload.checkout_url, 1000);
        if (!/^https:\/\//i.test(url)) throw new Error('Checkout-ul nu este disponibil.');
        window.location.assign(url);
      })
      .catch(function(error) {
        self.busy = false;
        self.show(error.message || 'Checkout-ul nu poate fi inițiat momentan.', true);
        if (error.status === 409) {
          self.quote = null;
          self.scheduleQuote();
        }
        self.updateCheckout();
      });
  };

  DualServices.prototype.show = function(message, error) {
    if (!this.status) return;
    this.status.textContent = message || '';
    this.status.classList.toggle('is-error', !!error);
  };

  function initialize() {
    if ((document.documentElement.lang || '').toLowerCase().indexOf('es') === 0) return;
    document.querySelectorAll('[data-faima-checkout]').forEach(function(root) {
      if (root.dataset.faimaDualServicesInitialized === 'true') return;
      root.dataset.faimaDualServicesInitialized = 'true';
      new DualServices(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

